import { Box, Typography } from "@mui/material";
import Caracal from "../../images/main-caracal.jpg";
import AnimatedSection from "../animations/AnimatedSection";

export default function MainHelloComponent() {
    return (
        <Box
            sx={{
                height: "80vh",
                minHeight: "500px",
                maxHeight: "1300px",
                width: "100%",
                position: "relative",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                color: "white",
                textAlign: "center",
                padding: { xs: "16px", sm: "20px" },
                boxSizing: "border-box",
                overflow: "hidden",

                "&::after": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 0,
                    backgroundImage: `url(${Caracal})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    animation: "heroZoom 18s ease-out forwards",
                    "@keyframes heroZoom": {
                        "0%": { transform: "scale(1.08)" },
                        "100%": { transform: "scale(1)" },
                    },
                },

                "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.4)",
                    zIndex: 1,
                },

                "& > *": {
                    zIndex: 2,
                    position: "relative",
                },
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: { xs: "center", md: "start" },
                    gap: 2,
                    px: { xs: 2, sm: 4 },
                    maxWidth: "100%",
                    width: "100%",
                }}
            >
                <AnimatedSection delay={200} duration={700}>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: { xs: "center", md: "start" },
                            maxWidth: "100%",
                            width: "100%",
                        }}
                    >
                        <Typography
                            sx={{
                                fontWeight: 500,
                                fontSize: {
                                    xs: "12px",
                                    sm: "12px",
                                    md: "16px",
                                    lg: "24px",
                                },
                                lineHeight: 1.3,
                                textTransform: "uppercase",
                            }}
                        >
                            Мы содержим африканский подвид каракала и разводим домашних животных с 2012 года
                        </Typography>
                    </Box>
                </AnimatedSection>
                <AnimatedSection delay={450} duration={700}>
                    <Typography
                        sx={{
                            fontWeight: 500,
                            fontSize: {
                                xs: "12px",
                                sm: "12px",
                                md: "16px",
                                lg: "24px",
                            },
                            lineHeight: 1.3,
                            textTransform: "uppercase",
                        }}
                    >
                        Наши животные — результат заботы, знаний и любви к дикой природе
                    </Typography>
                </AnimatedSection>
            </Box>
        </Box>
    );
}